module.exports = __webpack_public_path__ + "img/9788901146959.74c5fe1b.jpg";